const checkSoldOut = (data) => {
  return (
    data?.is_soldout === "Y" ||
    data?.is_emenu_disable === "Y" ||
    (data?.is_avl_limit_check === "Y" && data?.bal_qty === 0)
  );
};

export default checkSoldOut;
